const Invoice = (props) => {
    const { pdfRef, productOrderData } = props;

    return (
        <div ref={pdfRef} style={{ padding: 20, backgroundColor: '#fff', position:'absolute', zIndex: -1}} >
            <div className="invoice-container">
                <div className="header">
                    <h1>Order Invoice</h1>
                    <img src="images/logo.png" alt="Logo" />
                </div>

                <div className="invoice-details_weeper">
                    <div className="invoice-details">
                        <p><strong>Invoice :</strong> #{productOrderData?.order_id}</p>
                        {/* <p><strong>Shop Name:</strong> ZAAZ INDIA</p> */}

                    </div>
                    <p><strong>Date:</strong> {productOrderData?.order_date}</p>
                </div>

                <div className="details">
                    <div>
                        <strong>Shipping To:</strong><br />
                        {productOrderData?.billing_customer_name}<br />
                        {productOrderData?.billing_email}<br />
                        {productOrderData?.billing_phone}<br />
                        {productOrderData?.billing_address} {productOrderData?.billing_address_2},<br />
                        {productOrderData?.billing_city}, {productOrderData?.billing_state}, {productOrderData?.billing_country},<br />
                        {productOrderData?.billing_pincode}
                    </div>
                    <div className='text-right'>
                        <strong>Billing Address:</strong><br />
                        {productOrderData?.billing_customer_name}<br />
                        {productOrderData?.billing_email}<br />
                        {productOrderData?.billing_phone}<br />
                        {productOrderData?.billing_address} {productOrderData?.billing_address_2},<br />
                        {productOrderData?.billing_city}, {productOrderData?.billing_state}, {productOrderData?.billing_country},<br />
                        {productOrderData?.billing_pincode}
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>SL</th>
                            <th>Item</th>
                            <th>Unit Price</th>
                            <th>Qty</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productOrderData != null ?
                            productOrderData?.order_items.map((e, i) => (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{e?.name}</td>
                                    <td>&#8377;{e?.unit_price}</td>
                                    <td>{e?.units}</td>
                                    <td>&#8377;{e?.selling_price}</td>
                                </tr>
                            )) : null
                        }

                    </tbody>
                </table>

                <div className="payment_info_weepr">
                    <div className="payment-info">
                        <p><strong>Payment Details:</strong><br /> {productOrderData?.payment_method}, {productOrderData?.order_date}</p>
                        {/* <p><strong>Delivery Info:</strong> Trackon</p>
                        <p><strong>Tracking ID:</strong> 100206440792</p> */}
                    </div>

                    <div className="total">
                        <div className='amout_box_wrapper'>
                            <span>Sub Total: </span>
                            <span>&#8377;{productOrderData?.sub_total}</span>
                        </div>
                        <div className='amout_box_wrapper'>
                            <span>Tax: </span>
                            <span>&#8377;0</span>
                        </div>
                        <div className='amout_box_wrapper'>
                            <span>Shipping: </span>
                            <span>&#8377;{productOrderData?.shipping_charges}</span>
                        </div>
                        <div className='amout_box_wrapper'>
                            <span>Discount On Product: -</span>
                            <span>&#8377;{productOrderData?.total_discount}</span>
                        </div>
                        <div className='amout_box_wrapper'>
                            <span><strong>Total:</strong></span>
                            <span><strong>&#8377;{productOrderData?.sub_total}</strong> </span>
                        </div>
                    </div>
                </div>

                <div className="footer">
                    If you require any assistance or have feedback or suggestions about our site, you can email us at <br /> <a
                        href="mailto:officialjaipurtouch@gmail.com">gailee@gmail.com</a>
                </div>
            </div >
        </div >
    )
}

export default Invoice